export function affinityToStem(affinity: string): string {
  // affinity stems are just the base string of the affinity, so we need to remove the extra affinity markers to get the stem
  // examples where the stem is BIG:
  // STEM Affinity code (BIG)
  // STEM_X affinity code, where X is any combination of letters and numbers (BIG_123)
  // STEMBR affinity code(BIGBR)
  // STEMP affinity code(BIGP)

  // start by removing anything after underscore, then check if the last digit is P or BR, and remove those too
  const stem = affinity.split('_')[0];
  if (stem.endsWith('P')) {
    return stem.slice(0, stem.lastIndexOf('P'));
  }
  if (stem.endsWith('BR')) {
    return stem.slice(0, stem.lastIndexOf('BR'));
  }
  return stem;
}

/**
 * The upper-cased affinity stem of a policy's agency: the affinity on its most recent segment that
 * carries one, else a top-level `global.affinity`; null when it has none. The same rule as
 * staff-billing-details' getPolicyAffinity and staff-fe's resolvePolicyStem (#33155), used to find
 * the sweep account internal staff charge for an agent (#36683).
 */
export function getPolicyAffinityStem(policy: Record<string, any> | null | undefined): string | null {
  const segments = Array.isArray(policy?.segments) ? policy.segments : [];
  for (let i = segments.length - 1; i >= 0; i--) {
    const affinity = segments[i]?.global?.affinity;
    if (affinity) {
      return affinityToStem(affinity).toUpperCase();
    }
  }
  const topAffinity = policy?.global?.affinity;
  return topAffinity ? affinityToStem(topAffinity).toUpperCase() : null;
}
